export default {
  Common: 'common',
  DocumentMaster: 'document-master',
  ActiveUsers: 'active-users',
} as const;
